// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1EFvj","col":"styles_col__3zj7L","fulfillmentStatus":"styles_fulfillmentStatus__UYGNy","emailCol":"styles_emailCol__3lc4D"};